import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types';

import {
  PAGE_NOT_FOUND_ROUTE,
  REDIRECT_ROUTE,
  PAGE_REGISTER_ROUTE,
  PAGE_EXTERNAL_ROUTE,
  PAGE_FLOW_ROUTE,
  PAGE_COOPERATE_ROUTE,
  PAGE_HTML_TEMPLATE_ROUTE,
  PAGE_CONTENT_OPERATION_DETAIL_ROUTE,
} from '/@/router/routes/basic';

import { PageEnum } from '/@/enums/pageEnum';
import { t } from '/@/hooks/web/useI18n';

const modules = import.meta.globEager('./modules/**/*.ts');
const routeModuleList: AppRouteModule[] = [];

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('/@/views/sys/login/Login.vue'),
  meta: {
    title: t('routes.basic.login'),
  },
};

// export const FlowRouter: AppRouteRecordRaw = {
//   path: '/flowable',
//   name: 'flowable',
//   component: () => import('/@/views/flowable/definition/index.vue'),
//   meta: {
//     title: t('routes.basic.login'),
//   },
// };

// Basic routing without permission
export const basicRoutes = [
  LoginRoute,
  RootRoute,
  // live,
  REDIRECT_ROUTE,
  PAGE_REGISTER_ROUTE,
  PAGE_EXTERNAL_ROUTE,
  PAGE_FLOW_ROUTE,
  PAGE_COOPERATE_ROUTE,
  PAGE_HTML_TEMPLATE_ROUTE,
  PAGE_CONTENT_OPERATION_DETAIL_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
];
